import { callApi, ENDPOINTS } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import * as Types from 'apps/fleet-planner/types'

export const updateUserPassword = (
  payload: Types.IUpdateUserPasswordPayload
): Promise<Types.IUpdateUserPasswordResponse> => {
  return callApi({
    method: 'PUT',
    endpoint: ENDPOINTS.updatePassword,
    body: payload,
  })
}

export const updateUserSettings = (
  payload: Types.IUpdateUserSettingsPayload
): Promise<Types.IUpdateUserSettingsResponse> => {
  return callApi({
    method: 'PUT',
    endpoint: FP_ENDPOINTS.current_user,
    group: 'settings',
    body: payload,
  })
}

export const updateUserInfo = (
  payload: Types.IUpdateUserInfoPayload
): Promise<Types.IUpdateUserInfoResponse> => {
  return callApi({
    method: 'PUT',
    endpoint: FP_ENDPOINTS.current_user,
    body: payload,
  })
}

/**
 * Updates user association with array of motor carriers
 */
export const joinMotorCarriers = (
  payload: Types.IJoinMotorCarriersPayload
): Promise<Types.IJoinMotorCarriersResponse> => {
  return callApi({
    method: 'POST',
    endpoint: FP_ENDPOINTS.current_user,
    group: 'motor_carriers/join',
    body: payload,
  })
}
